import clsx from "clsx";

const TONE = {
  default: "bg-white",
  red: "bg-[#E62E2E] text-white",
  orange: "bg-[#E67300] text-black",
  blue: "bg-[#2E5CE6] text-white",
  black: "bg-black text-white",
};

export default function StatCard({ label, value, sub, tone = "default", testId }) {
  return (
    <div
      data-testid={testId}
      className={clsx(
        "border border-black p-5 md:p-6 flex flex-col gap-3",
        TONE[tone]
      )}
    >
      <span className="font-mono text-[11px] uppercase tracking-[0.25em] opacity-80">
        {label}
      </span>
      <span className="font-mono text-4xl md:text-5xl font-bold tracking-tight tabular-nums leading-none">
        {value}
      </span>
      {sub && (
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] opacity-70">
          {sub}
        </span>
      )}
    </div>
  );
}
